export const environment = {
  production: true,
  apiUrl: "https://api-ic.40parables.com"
};
